module.exports = __webpack_public_path__ + "img/e-kit_managers.75645183.png";